/* svnty-suggest.js: THE SUGGESTED ROW per shopper, and THE RECO BEACON (RECO_SVNTY_Part1,
 * 2026-09-26; svnty-reco 1.3 by RECO_SVNTY_Part2, 2026-09-26). Classic deferred script, no module, no dependency, no CDN; tagged by snippets/svnty-suggest-chips.liquid,
 * which may render more than once a page (the guard below). Wiring for the rest of the theme:
 * 02_architecture/RECO_TIER2_WIRING_2026-09-26.md.
 *
 * THE ROW. Every [data-svnty-suggest] root holds the static list (the theme setting). At idle this file asks
 *   /apps/reco/suggest (the reco worker behind Shopify's app proxy, same origin, no cookie reaches it) for this
 *   shopper's row: ?s (the session id, only with consent) &cs (the consent flags) &p (the product on screen) &c (the
 *   collection) &l (the locale) &n=8 &x (the chips the sheet already shows: RECENT and BROWSE, only with consent).
 *   A good answer (4 terms or more) replaces the chips of every root in one write; a door term (a store page, the size
 *   guide) links to its page, every other term searches exactly as the static chips do. Anything else (no answer in
 *   2.5 s, an error, a thin row) leaves the static list. Arabic terms are shown as the worker sends them, right to left.
 *   The same terms become the rotating placeholder: data-terms of every input[data-svnty-typewriter], then the document
 *   event 'svnty:suggest' {detail: {terms, id}} for the typewriter to re-read.
 * THE SESSION ID. 32 hex, random, made only when the consent gate says yes, kept in localStorage 'svnty:reco:sid' as
 *   {id, last}, and replaced after 30 minutes without activity: the worker can never link two visits of a guest.
 * THE BEACON (window.SVNTY.reco.push): events {t, h, c, ts, ctx, k, q, n} batched in memory, sent every 10 s or at 20
 *   events (fetch keepalive) and when the page hides (sendBeacon), 60 a batch, POST /apps/reco/events?t=<now>,
 *   body {s, dk, cs, ev} as text/plain (dk only with cs 'ap'). Nothing leaves the page without consent: before the privacy API answers, and while
 *   the banner waits, events wait in memory (100) for the answer; a refusal drops them. Events pushed by
 *   another file before this one loaded wait in window.SVNTY.recoQ and are drained here.
 * THE DEVICE KEY (window.SVNTY.reco.dk): 32 hex, random, kept in localStorage 'svnty:reco:dk' as {id, at}, made only
 *   when the shopper allows analytics AND preferences (cs 'ap'), sent only then, never rotated by idleness: it lets the
 *   worker keep this device's own taste across visits. When the consent state is known and preferences are withdrawn
 *   (cs lacks 'p') the worker is told to forget that key and the key alone is removed; the session id stays with analytics.
 * FORGET (window.SVNTY.reco.forget): the refusal, or the shopper's "clear my history". First POST /apps/reco/forget
 *   {s, dk, cs} (sendBeacon, else fetch keepalive; when an id is stored or the customer is signed in, P35-2 SEC-B-08) so the worker deletes the profile and every
 *   raw row, then the cart tag is blanked once, then the session id, the device key, the tag record and the queues go.
 * THE CART TAG: a kept 'add' writes the cart attribute _svnty_s = the session id through /cart/update.js (the underscore
 *   hides it at checkout), once per session id (the id last written: localStorage 'svnty:reco:cart'). The orders webhook
 *   reads it, so the worker learns what was bought without any personal data. Nothing else is ever written to the cart.
 * EVENT TYPES pass through as the theme sends them ('pick' is the worker's alias of 'colour'). 'purchase' is never sent
 *   from here (the worker writes it from the orders webhook): push() drops it.
 * WHAT THIS FILE RECORDS. qv when a served row is on screen (half of it, 1 s), once per row; qt when a chip is tapped
 *   (its row and position), sent at once; q on the results page (the query and its count) and when a product of the
 *   typeahead is opened (the query typed so far). The rest of the events are svnty-taste.js's (the wiring doc).
 */
(function () {
  'use strict';
  var SV = window.SVNTY = window.SVNTY || {};
  if (SV.reco) return;

  /* THE CONSENT GATE: the same object svnty-taste.js and svnty-recently-viewed.js define (whichever runs first). */
  (function () {
    if (SV.consent) return;
    var o = SV.consent = { state: 'unknown', subs: [] };
    function decide() {
      var c = null, s = '';
      try { c = window.Shopify && window.Shopify.customerPrivacy; } catch (e) {}
      if (!c || typeof c.shouldShowBanner !== 'function' || typeof c.analyticsProcessingAllowed !== 'function') return;
      try {
        var v = typeof c.currentVisitorConsent === 'function' ? (c.currentVisitorConsent() || {}) : {};
        s = !c.shouldShowBanner() || c.analyticsProcessingAllowed() ? 'yes' : (v.analytics === 'no' ? 'no' : 'pending');
      } catch (e) { return; }
      if (s === o.state) return;
      o.state = s;
      o.subs.slice().forEach(function (f) { try { f(s); } catch (e) {} });
    }
    o.keep = function () { return o.state === 'yes'; };
    o.on = function (f) { o.subs.push(f); };
    o.decide = decide;
    decide();
    try {
      if (o.state === 'unknown' && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) decide(); });
      }
    } catch (e) {}
    document.addEventListener('visitorConsentCollected', function () { setTimeout(decide, 0); });
    var n = 0, t = setInterval(function () { decide(); if (o.state !== 'unknown' || ++n > 60) clearInterval(t); }, 250);
  })();
  var C = SV.consent;

  var BASE = '/apps/reco', SID = 'svnty:reco:sid', DK = 'svnty:reco:dk', CART = 'svnty:reco:cart', IDLE = 30 * 60 * 1000, TIMEOUT = 2500, MIN_ROW = 4;
  /* P35-2 (svnty-reco 1.5.3, SEC-B-08): the worker's GETs no longer delete anything, so a signed-in customer's withdrawal is said by
     POST /apps/reco/forget even when nothing is stored on this device (the worker knows her by Shopify's logged_in_customer_id, never
     by the theme). The automatic withdrawal says it once per tab (svnty:reco:told, re-armed when preferences come back); "clear my
     history" says it every time. A guest with nothing stored sends nothing, as before. */
  var SIGNED_IN = !!document.querySelector('script[data-svnty-signed-in]'), TOLD = 'svnty:reco:told';
  function toldOnce() { try { if (sessionStorage.getItem(TOLD) === '1') return true; sessionStorage.setItem(TOLD, '1'); } catch (e) {} return false; }
  /* THE QA FENCE (svnty-reco 1.5.0): the builders' own traffic is answered and never learned from. QA = a preview or dev theme,
     the theme editor, automation (navigator.webdriver), a local host, or a device marked with ?svnty_qa=1 (?svnty_qa=0 clears) */
  var QA = (function () {
    var S = window.Shopify || {}, th = S.theme || {}, mark = '';
    /* P35-2 (SEC-A-15): ?svnty_qa=1 marks a device only from a preview or development theme or the theme editor (a link to the live
       theme can no longer take a shopper out of what the recommender learns); ?svnty_qa=0 clears the mark anywhere */
    try { var m = /[?&]svnty_qa=([01])(?:&|$)/.exec(location.search); if (m) { if (m[1] === '1') { if (S.designMode || (th.role && th.role !== 'main')) localStorage.setItem('svnty:qa', '1'); } else localStorage.removeItem('svnty:qa'); } } catch (e) {}
    try { mark = localStorage.getItem('svnty:qa') || ''; } catch (e) {}
    return !!((th.role && th.role !== 'main') || S.designMode || navigator.webdriver === true || /^(127\.0\.0\.1|localhost|\[::1\])$/.test(location.hostname) || mark === '1');
  })();
  var ob = [], held = [], timer = 0, row = null, seenRows = {};
  C.on(function (state) {
    if (state === 'yes') held.splice(0).forEach(push);
    else if (state === 'no') forget();
    prune();
  });
  /* a change of the preferences alone does not move the gate's state: every answer of the banner is read here too */
  document.addEventListener('visitorConsentCollected', function () { setTimeout(prune, 0); });
  if (C.state === 'no') setTimeout(forget, 0);
  /* the stored {id, ...} under a key, or null; never makes one */
  function stored(key) {
    var v = null;
    try { v = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { v = null; }
    return v && typeof v.id === 'string' && /^[0-9a-f]{32}$/.test(v.id) ? v : null;
  }
  function drop(key) { try { localStorage.removeItem(key); } catch (e) {} }
  /* one POST as text/plain: sendBeacon when asked (it outlives the page), else fetch keepalive */
  function post(url, body, beacon) {
    var sent = false;
    if (beacon && navigator.sendBeacon) { try { sent = navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })); } catch (e) { sent = false; } }
    if (!sent) { try { fetch(url, { method: 'POST', body: body, keepalive: true, credentials: 'same-origin', headers: { 'content-type': 'text/plain' } }).catch(function () {}); } catch (e) {} }
  }
  /* the cart attribute _svnty_s, the only thing this file ever writes to the cart; errors are swallowed */
  /* P28 lane E (launch audit cart P2-9): the tag is remembered as written only when the store took it (ok); a refusal or a
     dropped line leaves it unwritten, so the next kept event asks again (the attribute write is idempotent) */
  function cartTag(v, onOk) {
    var o = { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'content-type': 'application/json' } };
    o.body = JSON.stringify({ attributes: { _svnty_s: v } });
    try { fetch('/cart/update.js', o).then(function (r) { if (r.ok && onOk) onOk(); }).catch(function () {}); } catch (e) {}
  }
  /** forget(): the refusal, or "clear my history": the worker deletes first, then the cart tag, the ids and the queues go. */
  function forget(force) {
    held = []; ob = [];
    if (timer) { clearTimeout(timer); timer = 0; }
    var s = stored(SID), k = stored(DK), tagged = '';
    try { tagged = localStorage.getItem(CART) || ''; } catch (e) {}
    if (s || k || (SIGNED_IN && (force === true || !toldOnce()))) { var b = { s: s ? s.id : '' }; if (k) b.dk = k.id; b.cs = cs(); post(BASE + '/forget', JSON.stringify(b), true); }
    if (tagged) cartTag('');
    [SID, DK, CART].forEach(drop);
  }
  /** prune(): preferences withdrawn (state known, cs without 'p'), a device key stored: the worker forgets that key's
      profile (s is sent empty: the session's rows stay with analytics), and the key alone is removed. */
  function prune() {
    var k = stored(DK);
    if (C.state === 'unknown' || C.state === 'no') return;
    if (cs().indexOf('p') >= 0) { try { sessionStorage.removeItem(TOLD); } catch (e) {} return; }
    if (!k && !(SIGNED_IN && !toldOnce())) return;   // P35-2 SEC-B-08: a signed-in customer is told to the worker with no key stored
    var b = { s: '' }; if (k) b.dk = k.id; b.cs = cs();
    post(BASE + '/forget', JSON.stringify(b), true);
    if (k) drop(DK);
  }

  /* the consent flags the worker reads: a = analytics (or no banner required here), p = preferences */
  function cs() {
    if (!C.keep()) return '';
    var a = 'a', p = '';
    try { var c = window.Shopify.customerPrivacy; if (c.preferencesProcessingAllowed && c.preferencesProcessingAllowed()) p = 'p'; } catch (e) {}
    return a + p;
  }
  function hex(n) {
    var b = new Uint8Array(n);
    (window.crypto || window.msCrypto).getRandomValues(b);
    var s = '';
    for (var i = 0; i < b.length; i++) s += (b[i] < 16 ? '0' : '') + b[i].toString(16);
    return s;
  }
  /** sid(): the session id, or '' without consent; touching it keeps the session alive. */
  function sid() {
    if (!C.keep()) return '';
    var now = Date.now(), v = null;
    try { v = JSON.parse(localStorage.getItem(SID) || 'null'); } catch (e) { v = null; }
    if (!v || typeof v.id !== 'string' || !/^[0-9a-f]{32}$/.test(v.id) || !(now - v.last < IDLE)) v = { id: hex(16), last: now };
    v.last = now;
    try { localStorage.setItem(SID, JSON.stringify(v)); } catch (e) {}
    return v.id;
  }
  /** dk(): the device key, or '' unless cs() is 'ap'; made here the first time both consents hold. */
  function dk() {
    if (cs() !== 'ap') { prune(); return ''; }
    var v = stored(DK);
    if (!v) { v = { id: hex(16), at: Date.now() }; try { localStorage.setItem(DK, JSON.stringify(v)); } catch (e) {} }
    return v.id;
  }
  /* THE CART TAG: once per session id, only for a kept event */
  function tag() {
    var s = sid(), last = '';
    try { last = localStorage.getItem(CART) || ''; } catch (e) {}
    var mark = QA ? 'qa:' + s : s;
    if (!s || last === mark) return;
    cartTag(QA ? 'qa' : s, function () { try { localStorage.setItem(CART, mark); } catch (e) {} });
  }

  /* THE BEACON */
  function clean(e) {
    if (!e || typeof e.t !== 'string' || !e.t || e.t === 'purchase') return null;
    var o = { t: e.t, ts: typeof e.ts === 'number' && e.ts > 0 ? Math.min(e.ts, Date.now()) : Date.now() };
    ['h', 'c', 'ctx', 'q'].forEach(function (k) { if (typeof e[k] === 'string' && e[k]) o[k] = e[k].slice(0, 120); });
    if (Array.isArray(e.k)) o.k = e.k.filter(function (x) { return typeof x === 'string'; }).slice(0, 6);
    if (typeof e.n === 'number' && isFinite(e.n)) o.n = Math.max(0, Math.round(e.n));
    return o;
  }
  /** push(e): queues one event, sends at 20 or within 10 s. Until the privacy API has answered (unknown) or while the
      banner waits for the shopper (pending), the event is held in this page's memory only (100 newest): a yes sends it,
      a no drops it. Refused: dropped at once. */
  function push(e) {
    var o = clean(e);
    if (!o || C.state === 'no') return false;
    if (!C.keep()) { held.push(o); if (held.length > 100) held.splice(0, held.length - 100); return false; }
    ob.push(o);
    if (o.t === 'add') tag();
    if (ob.length > 200) ob.splice(0, ob.length - 200);
    if (ob.length >= 20) flush(false);
    else if (!timer) timer = setTimeout(function () { timer = 0; flush(false); }, 10000);
    return true;
  }
  /** flush(hidden): sends what is queued, 60 a batch; sendBeacon when the page is going away. An empty queue sends nothing
      and touches no id (TASTE_CONSENT, 2026-09-26: every pagehide minted the session id and the device key with nothing to
      send, so a page left right after a Clear or a refusal wrote them straight back). */
  function flush(hidden) {
    if (timer) { clearTimeout(timer); timer = 0; }
    if (!ob.length) return;
    var s = sid();
    if (!s) { ob = []; return; }
    var c = cs(), k = dk();
    while (ob.length) {
      var b = { s: s };
      if (k) b.dk = k;
      b.cs = c; if (QA) b.qa = 1; b.ev = ob.splice(0, 60);
      post(BASE + '/events?t=' + Date.now(), JSON.stringify(b), hidden);
    }
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(true); });
  window.addEventListener('pagehide', function () { flush(true); });

  /* THE ROW */
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function roots() { return $$('[data-svnty-suggest]'); }
  /* THE WORLDS ON HOLD (R297, 2026-09-29): the theme's switch off prints data-worlds-off; the row drops the reco's world terms */
  function worldsOff() { return !!document.querySelector('[data-svnty-suggest][data-worlds-off]'); }
  function dec(s) { try { return decodeURIComponent(s); } catch (e) { return ''; } }
  function context() {
    var r = roots()[0] || { dataset: {} }, d = r.dataset || {}, m;
    var p = d.p || ((m = /\/products\/([^/?#]+)/.exec(location.pathname)) ? dec(m[1]) : '');
    var c = d.c || ((m = /\/collections\/([^/?#]+)/.exec(location.pathname)) ? dec(m[1]) : '');
    return { p: p, c: c === 'all' ? '' : c, l: d.l || document.documentElement.lang || '' };
  }
  /* the chips the sheet already shows (its RECENT searches and its BROWSE row), sent only with consent */
  function shown() {
    var out = [];
    $$('svnty-recent-searches a, .svnty-search__recent-term').forEach(function (a) { out.push((a.textContent || '').trim()); });
    $$('.svnty-search__default .svnty-search__sec').forEach(function (sec) {
      if (sec.hasAttribute('data-svnty-suggest')) return;
      $$('a.svnty-chip', sec).forEach(function (a) { if (!/[?&]q=/.test(a.getAttribute('href') || '')) out.push((a.textContent || '').trim()); });
    });
    var seen = {};
    return out.filter(function (t) { var k = t.toLowerCase(); if (!t || seen[k]) return false; seen[k] = 1; return true; }).slice(0, 16);
  }
  function searchUrl(root) {
    return (root && root.dataset.search) || (window.routes && window.routes.search_url) || '/search';
  }
  function isArabic(s) { return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(s || ''); }
  function chip(root, t, i, id) {
    var a = document.createElement('a');
    a.className = 'svnty-chip';
    var door = t.k === 'door' && typeof t.href === 'string' && /^\/pages\/[a-z0-9-]+$/.test(t.href);
    a.href = door ? t.href : searchUrl(root) + '?q=' + encodeURIComponent(t.q) + '&options%5Bprefix%5D=last';
    a.textContent = t.q;
    a.setAttribute('data-svnty-suggest-term', '');
    a.setAttribute('data-k', t.k || '');
    a.setAttribute('data-pos', String(i + 1));
    if (id) a.setAttribute('data-row', String(id));
    if (isArabic(t.q)) a.setAttribute('dir', 'rtl');
    return a;
  }
  function render(r, onlyNew) {
    roots().forEach(function (root) {
      if (onlyNew && root.getAttribute('data-svnty-suggest')) return;
      var box = root.querySelector('[data-svnty-suggest-chips]');
      if (!box) return;
      if (box.contains(document.activeElement)) {
        /* never move a chip under the shopper's focus: the row lands when the focus leaves it */
        if (!root.__svntyWait) {
          root.__svntyWait = 1;
          box.addEventListener('focusout', function once() { box.removeEventListener('focusout', once); root.__svntyWait = 0; setTimeout(function () { root.setAttribute('data-svnty-suggest', ''); render(row || r, true); }, 0); });
        }
        return;
      }
      var frag = document.createDocumentFragment();
      r.row.forEach(function (t, i) { frag.appendChild(chip(root, t, i, r.id)); });
      box.textContent = '';
      box.appendChild(frag);
      root.setAttribute('data-svnty-suggest', r.id ? 'row' : 'cold');
      watch(root, r.id);
    });
    if (onlyNew) return;
    var terms = r.row.filter(function (t) { return t.k !== 'door'; }).map(function (t) { return t.q; });
    $$('input[data-svnty-typewriter]').forEach(function (inp) { inp.setAttribute('data-terms', terms.join(', ')); });
    try { document.dispatchEvent(new CustomEvent('svnty:suggest', { detail: { terms: terms, id: r.id || null } })); } catch (e) {}
  }
  /* a row is seen when half of it is on screen for one second: then, once, qv */
  function watch(root, id) {
    if (!id || seenRows[id] || !window.IntersectionObserver) return;
    if (root.__svntyIo) root.__svntyIo.disconnect();
    var t = 0;
    var io = root.__svntyIo = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (x.isIntersecting && x.intersectionRatio >= 0.5) {
          if (!t) t = setTimeout(function () { if (!seenRows[id]) { seenRows[id] = 1; push({ t: 'qv', ctx: 'sugg@' + id + '#0' }); } io.disconnect(); }, 1000);
        } else if (t) { clearTimeout(t); t = 0; }
      });
    }, { threshold: 0.5 });
    io.observe(root);
  }
  /* P17-19 (code health P3-8, THE iOS TAP LAW): the door's first press only asks; an answer that lands inside a tap (a press
     less than 600 ms ago, the press-to-click window with room to spare) is drawn after it, so nothing is written to the page
     between a press and its click. The chips then land in the sheet the click opened, or in the closed one. */
  var pressAt = -1e9;
  document.addEventListener('pointerdown', function () { pressAt = performance.now(); }, { capture: true, passive: true });
  function paintSoon(r) {
    var wait = 600 - (performance.now() - pressAt);
    if (wait > 0) { setTimeout(function () { paintSoon(r); }, wait); return; }
    if (r === row) render(r);
  }
  function load() {
    if (!roots().length || load.p) return load.p;
    var ctx = context(), s = sid(), q = ['n=8'];
    if (QA) q.push('qa=1');
    if (s) { q.push('s=' + s, 'cs=' + cs()); var x = shown(); if (x.length) q.push('x=' + encodeURIComponent(x.join('|'))); }
    if (ctx.p) q.push('p=' + encodeURIComponent(ctx.p));
    if (ctx.c) q.push('c=' + encodeURIComponent(ctx.c));
    if (/^(ar|en)/.test(ctx.l)) q.push('l=' + ctx.l.slice(0, 2));
    var ctl = window.AbortController ? new AbortController() : null;
    var kill = setTimeout(function () { if (ctl) ctl.abort(); }, TIMEOUT);
    load.p = fetch(BASE + '/suggest?' + q.join('&'), { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (j) {
        clearTimeout(kill);
        if (!j || !Array.isArray(j.row) || j.row.length < MIN_ROW) return null;
        /* P17-29 (round 3, eye pass R2 A P2-8 and B P3-18; Law 1): a search row never routes to the branches; the locator's doors
           are the burger's and the footer's. The worker's stores door ("Find a store") is dropped here, whatever its handle. */
        var ok = j.row.filter(function (t) { return t && typeof t.q === 'string' && t.q.length > 0 && t.q.length <= 60 && !(t.k === 'world' && worldsOff()) && !(t.k === 'door' && /locator|stores|branches|find-a-store/.test((t.key || '') + ' ' + (t.href || ''))); });
        if (ok.length < MIN_ROW) return null;
        row = { id: typeof j.id === 'number' ? j.id : null, row: ok.slice(0, 8) };
        paintSoon(row);
        return row;
      })
      .catch(function () { clearTimeout(kill); return null; });
    return load.p;
  }

  /* WHAT THIS FILE RECORDS */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-svnty-suggest-term]');
    if (a) {
      var id = a.getAttribute('data-row');
      if (id) { push({ t: 'qt', q: (a.textContent || '').trim(), ctx: 'sugg@' + id + '#' + (a.getAttribute('data-pos') || '0') }); flush(true); }
      return;
    }
    var p = e.target && e.target.closest && e.target.closest('[data-predictive-search] a[href*="/products/"]');
    if (p) {
      var form = p.closest('form'), inp = form && form.querySelector('input[name="q"]');
      var v = inp && (inp.value || '').trim();
      if (v) { push({ t: 'q', q: v }); flush(true); }
    }
  }, true);
  function recordSearchPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var q = '';
    try { q = (new URLSearchParams(location.search).get('q') || '').trim(); } catch (e) { q = ''; }
    if (!q) return;
    var el = document.querySelector('[data-svnty-suggest][data-n]'), n = el ? Number(el.getAttribute('data-n')) : NaN;
    var ev = { t: 'q', q: q };
    if (isFinite(n)) ev.n = n;
    push(ev);
  }

  SV.reco = {
    sid: sid, qa: QA, dk: dk, cs: cs, push: push, flush: flush, load: load, forget: function () { forget(true); },   // P35-2: "clear my history" always tells the worker
    paint: function () { if (row) render(row, true); },
    row: function () { return row; }
  };
  /* events another file pushed before this one loaded (svnty-taste.js: window.SVNTY.recoQ) */
  (SV.recoQ || []).splice(0).forEach(push);

  function boot() {
    recordSearchPage();
    var go = function () { load(); };
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1200);
    /* a first touch of a search door or field asks at once, so the sheet opens on the shopper's row */
    ['pointerdown', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function h(e) {
        var t = e.target;
        if (t && t.closest && t.closest('.header__icon--search, details-modal summary, input[name="q"], [data-svnty-suggest]')) { document.removeEventListener(type, h, true); load(); }
      }, true);
    });
    /* a root that arrives later (the sheet's empty state, drawn by the Section Rendering API) gets the row already held;
       a painted root carries data-svnty-suggest="row" or "cold", a fresh one the empty attribute */
    if (window.MutationObserver) {
      var queued = 0;
      new MutationObserver(function () {
        if (queued || !row) return;
        queued = 1;
        (window.requestAnimationFrame || setTimeout)(function () { queued = 0; if (document.querySelector('[data-svnty-suggest=""]')) render(row, true); });
      }).observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
    /* consent arrives later: the next load carries the session */
    C.on(function (state) { if (state === 'yes' && !(row && row.id)) { load.p = null; load(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
